const Caret = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
    >
      <path
        d='M1.99951 3.99805L5.99951 7.99805L9.99951 3.99805'
        stroke='#111111'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

Caret.displayName = 'Caret';
export default Caret;
